<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <template v-if="paso == 1">
                <h2>Selección de documentos</h2>
                <DropZone></DropZone>
            </template>
            <div style="display:flex;">
                <el-button v-if="working == 'documentos'" type="primary" icon="Back" @click="$router.go(-1)" :disabled="leftDisabled" />
                <el-button v-if="configEnvio.accion != 'firmar' && configEnvio.accion != 'nominas'" type="primary" icon="Right" :disabled="rightDisabled" @click="$router.push('/selecttarget')" />
                <el-button v-if="configEnvio.accion == 'firmar'" :type="working == 'firmas' ? 'warning' : 'primary'" icon="Right" :disabled="rightDisabled" @click="$router.push('/selectemit')" />
                <el-button v-if="configEnvio.accion == 'nominas'" type="primary" icon="Right" :disabled="rightDisabled" @click="$router.push('/sendpaybills')" />
        </div>
        </div>
    </el-col>
</template>

<script>
// import { ElNotification } from 'element-plus';
// import { curl } from '@/api.js';
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
import DropZone from '../components/inputs/DropZone.vue';
export default {
    name: 'SeleccionDocumentos',
    watch: {
    },
    components: {
        DropZone
    },
    data() {
        return {
            loading: false,
            paso: 1,
            tipoDocumento: '',
            acciones: {},
            working: process.env.VUE_APP_WORKING
        }
    },
    mounted() {

    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio', 'files', 'pub_titulo'
        ]),
        leftDisabled() {
            return false;
        },
        rightDisabled() {
            if(this.files.length == 0) {
                return true;
            }
            if(this.configEnvio.entrada == 'pdf' && this.configEnvio.accion == 'almacenar' && !this.pub_titulo) {
                return true;
            }
            return false;
        }
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores'
        ]),
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }

    .actionList {
        list-style: none;
        min-width: 50%;
        padding: 0px;

        .tipodocumento {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding: 10px;
            border: 2px solid #a9a9a929;
            margin-bottom: 10px;
            border-radius: 10px;
            font-weight: bold;
            transition: 0.5s;
            justify-content: flex-start;

            &:hover {
                background-color: #a9a9a929;
                border-color: #a9a9a929;
            }

            .icono {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 50px;
                background: #0985e325;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }
}
</style>